import { DeleteModal } from "@/components/modal/DeleteModal.tsx";
import { useStandardMutation } from "@/modules/api/useStandardMutation.ts";
import { DeleteWithFloatingIp } from "@/modules/network/DeleteWithFloatingIp.tsx";
import * as ipQuery from "@/modules/network/ipAddress/ipAddressApi.ts";
import type { LoadBalancerWithAssigned } from "@/modules/network/ipAddress/joinAssignedQuery.ts";
import type { DeleteLoadBalancerMutation } from "@/modules/network/loadbalancer/LoadBalancerView.tsx";
import { Trans } from "@lingui/react/macro";
import { useState } from "react";

export function LoadBalancerDeleteModal({
    item,
    deleteMutation,
}: {
    item: LoadBalancerWithAssigned;
    deleteMutation: DeleteLoadBalancerMutation;
}) {
    //#region Hooks
    const [deleteFloatingIp, setDeleteFloatingIp] = useState<boolean>();
    const deleteIpAddressMutation = useStandardMutation(ipQuery.deleteIpAddressMutation);
    //#endregion

    const { location, uuid, assignedPublicIp } = item;

    async function onDelete() {
        await deleteMutation.mutateAsync({ location, uuid });
        if (deleteFloatingIp) {
            await deleteIpAddressMutation.mutateAsync({ location, address: assignedPublicIp!.address });
        }
    }

    return (
        <DeleteModal
            isActionDisabled={!!assignedPublicIp && deleteFloatingIp == null}
            modalAction={async () => await onDelete()}
        >
            <Trans>This will stop forwarding traffic to the targets and remove the load balancer.</Trans>
            <DeleteWithFloatingIp
                ipAddress={assignedPublicIp ?? undefined}
                value={deleteFloatingIp}
                onChange={setDeleteFloatingIp}
            />
        </DeleteModal>
    );
}
